import React__default from 'react';
import { Icon } from '../Icon/Icon.component.js';
import { NavLinkButton } from './NavLinkButton.component.js';
import { getLinkClassName } from './utils/getLinkClassName.js';
import styles from './LeftNavAppMenu.module.scss.js';

var getIconName = function (link, selectedNavId) {
    if (link.isActive || selectedNavId === link.id) {
        return 'ChevronUpIcon';
    }
    return 'ChevronDownIcon';
};
var renderIcon = function (link) {
    return typeof link.icon === 'string' ? (React__default.createElement(Icon, { name: link.selectedIcon && link.isActive
            ? link.selectedIcon
            : link.icon, alt: link.icon, size: 24 })) : (link.icon);
};
var NavLink = function (_a) {
    var link = _a.link, handleSelectLink = _a.handleSelectLink, selectedNavId = _a.selectedNavId;
    return (React__default.createElement(NavLinkButton, { className: getLinkClassName(link, 'NavLink', link.className), link: link, onClick: handleSelectLink },
        React__default.createElement("div", { className: styles.NavLink_icon }, renderIcon(link)),
        React__default.createElement("span", { className: styles.NavLink_text }, link.displayName),
        !!link.subLinks.length && (React__default.createElement(Icon, { className: styles.NavLink_arrowIcon, name: getIconName(link, selectedNavId), alt: "link arrow", size: 24 }))));
};
NavLink.displayName = 'NavLink';

export { NavLink };
